<div>
    <vb-breadcrumb-one></vb-breadcrumb-one>

    <!-- shop area - start -->
    <section class="tp-shop-area pb-120">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="tp-shop-main-wrapper">
                        <div class="tp-shop-top mb-20">
                            <!-- Search, view toggle, and filter button — one row. -->
                            <div class="tp-shop-toolbar d-flex flex-wrap align-items-center">
                                <vb-search
                                    #searchBar
                                    class="tp-shop-search"
                                    placeholder="Search for auctions in this list"
                                    ariaLabel="Search for auctions in this list"
                                    [delegateSearch]="true"
                                    (search)="onSearch($event)" />
                                <!-- Toggle view -->
                                <div
                                    class="tp-shop-top-left d-flex align-items-center">
                                        <!-- Tab view toggle between list and grid —
                                             hidden on phone widths, where the card
                                             view is automatic (not a blocked choice). -->
                                        <div class="tp-shop-top-tab tp-tab" *ngIf="!isPhone">
                                            <ul class="nav nav-tabs">
                                                <!-- Grid View Button -->
                                                <li
                                                    class="nav-item"
                                                    role="presentation">
                                                    <button
                                                        [ngClass]="{
                                                            'nav-link': true,
                                                            active:
                                                                activeTab ===
                                                                'grid'
                                                        }"
                                                        (click)="
                                                            handleActiveTab(
                                                                'grid'
                                                            )
                                                        ">
                                                        <svg
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 18 18"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M16.3327 6.01341V2.98675C16.3327 2.04675 15.906 1.66675 14.846 1.66675H12.1527C11.0927 1.66675 10.666 2.04675 10.666 2.98675V6.00675C10.666 6.95341 11.0927 7.32675 12.1527 7.32675H14.846C15.906 7.33341 16.3327 6.95341 16.3327 6.01341Z"
                                                                stroke="currentColor"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                            <path
                                                                d="M16.3327 15.18V12.4867C16.3327 11.4267 15.906 11 14.846 11H12.1527C11.0927 11 10.666 11.4267 10.666 12.4867V15.18C10.666 16.24 11.0927 16.6667 12.1527 16.6667H14.846C15.906 16.6667 16.3327 16.24 16.3327 15.18Z"
                                                                stroke="currentColor"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                            <path
                                                                d="M7.33268 6.01341V2.98675C7.33268 2.04675 6.90602 1.66675 5.84602 1.66675H3.15268C2.09268 1.66675 1.66602 2.04675 1.66602 2.98675V6.00675C1.66602 6.95341 2.09268 7.32675 3.15268 7.32675H5.84602C6.90602 7.33341 7.33268 6.95341 7.33268 6.01341Z"
                                                                stroke="currentColor"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                            <path
                                                                d="M7.33268 15.18V12.4867C7.33268 11.4267 6.90602 11 5.84602 11H3.15268C2.09268 11 1.66602 11.4267 1.66602 12.4867V15.18C1.66602 16.24 2.09268 16.6667 3.15268 16.6667H5.84602C6.90602 16.6667 7.33268 16.24 7.33268 15.18Z"
                                                                stroke="currentColor"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                </li>
                                                <!-- List View Button -->
                                                <li
                                                    class="nav-item"
                                                    role="presentation">
                                                    <button
                                                        [ngClass]="{
                                                            'nav-link': true,
                                                            active:
                                                                activeTab ===
                                                                'list'
                                                        }"
                                                        (click)="
                                                            handleActiveTab(
                                                                'list'
                                                            )
                                                        ">
                                                        <svg
                                                            width="16"
                                                            height="15"
                                                            viewBox="0 0 16 15"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M15 7.11108H1"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                            <path
                                                                d="M15 1H1"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                            <path
                                                                d="M15 13.2222H1"
                                                                stroke="currentColor"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                </div>
                                <!-- Filters trigger + reset -->
                                <div class="auction-filter-controls">
                                    <vb-button
                                        [variant]="
                                            appliedFilterCount > 0 ? 'primary' : 'secondary'
                                        "
                                        size="md"
                                        [iconLeft]="filterIcon"
                                        (clicked)="openFilterModal()">
                                        {{ 'AuctionsPage.filtersLabel' | translate }}
                                        <span
                                            *ngIf="appliedFilterCount > 0"
                                            class="auction-filter-badge">
                                            {{ appliedFilterCount }}
                                        </span>
                                    </vb-button>
                                    <ng-template #filterIcon>
                                        <vb-icon name="filter" [size]="16"></vb-icon>
                                    </ng-template>
                                    <button
                                        *ngIf="appliedFilterCount > 0"
                                        type="button"
                                        class="auction-filter-reset"
                                        (click)="resetFilters()">
                                        {{ 'AuctionsPage.resetFiltersLabel' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            *ngIf="isLoading"
                            class="vb-spinner-box vb-spinner-box--page">
                            <vb-spinner
                                size="xl"
                                label="Loading auctions"></vb-spinner>
                        </div>

                        <ng-container *ngIf="!isLoading">
                        <!-- Pagination (top) -->
                        <vb-paginator-bar
                            variant="top"
                            label="auctions"
                            [dense]="isMobile"
                            [current]="paginate.currentPage ?? 1"
                            [total]="paginate.totalPages ?? 0"
                            [totalItems]="paginate.totalItems ?? 0"
                            [perPage]="pageSize"
                            [perPageOptions]="pageSizeOptions"
                            (pageChange)="onPageChange($event)"
                            (perPageChange)="setPageSize($event)">
                        </vb-paginator-bar>

                        <div class="tp-shop-items-wrapper tp-shop-item-primary">
                            <!-- Unable to load list view empty error -->
                            <div
                                *ngIf="unableToLoad"
                                class="cartmini__empty text-center min-height-30">
                                <img
                                    src="/assets/img/product/cartmini/empty-cart.png"
                                    alt="empty-cart-img" />
                                <h4>
                                    Something went wrong, unable to load
                                    Auctions!
                                </h4>
                            </div>
                            <!-- if no item in product  -->
                            <div
                                *ngIf="!unableToLoad && !auctions.length"
                                class="cartmini__empty text-center min-height-30">
                                <img
                                    src="/assets/img/product/cartmini/empty-cart.png"
                                    alt="empty-cart-img" />
                                <h4>No Auctions available!</h4>
                            </div>

                            <ng-container
                                *ngIf="!unableToLoad && auctions.length">
                                <!-- Grid View -->
                                <div *ngIf="effectiveTab === 'grid'">
                                    <div class="row infinite-container">
                                        <div
                                            *ngFor="let auction of auctions"
                                            class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                            <!-- Carousel card -->
                                             <vb-carousel-auction [auction]="auction" [isGridView]="true" />
                                        </div>
                                    </div>
                                </div>
                                <!-- List View -->
                                <div *ngIf="effectiveTab === 'list'">
                                    <ng-container
                                        *ngFor="
                                            let auction of auctions;
                                            let i = index;
                                            let last = last
                                        ">
                                        <!-- Carousel card -->
                                        <vb-carousel-auction
                                            [auction]="auction">
                                        </vb-carousel-auction>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Pagination (bottom) -->
                        <vb-paginator-bar
                            variant="bottom"
                            label="auctions"
                            [dense]="isMobile"
                            [current]="paginate.currentPage ?? 1"
                            [total]="paginate.totalPages ?? 0"
                            [totalItems]="paginate.totalItems ?? 0"
                            [perPage]="pageSize"
                            (pageChange)="onPageChange($event)">
                        </vb-paginator-bar>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- shop area end -->

    <vb-auction-filter-modal
        [open]="filterModalOpen"
        [draft]="filterDraft"
        [types]="filterTypes"
        [matchCount]="filterMatchCount"
        [statusCounts]="filterStatusCounts"
        [typeCounts]="filterTypeCounts"
        (draftChange)="onFilterDraftChange($event)"
        (apply)="onFilterApply()"
        (closed)="onFilterClosed()">
    </vb-auction-filter-modal>
</div>
